import EnvConstants from '@/constants/environment';

// @ts-ignore
__webpack_public_path__ = `${EnvConstants.ASSET_PATH}/`;
